module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dataLoaded && _vm.products && _vm.products.length) ? _c('div', {
    staticClass: "suggest-products"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_vm._v(_vm._s(_vm.android ? '随便逛逛' : _vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "products flex-wrap"
  }, _vm._l((_vm.products), function(item, index, i) {
    return _c('product', {
      attrs: {
        "source": _vm.source,
        "data": item,
        "miniEnv": _vm.miniEnv,
        "businessCase": _vm.businessCase,
        "index": index,
        "float": (index >= 0) ? index + 1 : (i + 1)
      }
    })
  }), 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7901fabc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/components/suggest-products/index.vue
// module id = 434
// module chunks = 2 6 10 14 20 64 66